export default {
  title: 'Marketing KPI Contribution by Microaudience (USD)',
  infoDialog: 'Projected KPI contribution by demographic micro audiences',
  kpi: 'KPI'
}
